module.exports = __webpack_public_path__ + "img/t2-c31.812090ee.png";